import React from "react"
import SbEditable from "storyblok-react"
import { render } from "storyblok-rich-text-react-renderer"
import { useStaticQuery, graphql } from "gatsby"
import DynamicComponent from './DynamicComponent'
import 'styles/pages/_BlogPost.scss'
import { Helmet } from 'react-helmet'

import {
  LinkedinShareButton,
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  PinterestShareButton,
  TwitterIcon,
  FacebookIcon,
  LinkedinIcon,
  EmailIcon,
} from "react-share";
import { GatsbySeo } from 'gatsby-plugin-next-seo';

const BlogPost = ({ blok, story, location }) => {

  let url = location?.href;

  let { content, full_slug } = story
  let { title, image, intro } = content;
  let theImage = `https:${image}`
  let url2 = `https://farmair.io${location.pathname}`;
  return (
    <>

      <GatsbySeo
          title={`farmAIr Blog - ${title}`}
          description={intro}
          canonical={url2}
          openGraph={{
            url: url2,
            title: title,
            description: intro,
            images: [
              {
                url: theImage,
                width: 640,
                height: 360,
                alt: title,
              }
            ],
          }}
        />
      <SbEditable content={blok} key={blok._uid}>
        <section className="page-blog-post sec-pad-std fade-in">
          <div className="inner">
            <div className="container">
              <h1 className="color-black">
                {blok.title}
              </h1>
              <div className="social-wrap">
                <div className="share-title">
                  <p>Share</p>
                </div>
                <div className="icons-wrap">
                  <LinkedinShareButton url={url}>
                    <LinkedinIcon size={32} round={true} />
                  </LinkedinShareButton>
                  <FacebookShareButton url={url}>
                    <FacebookIcon size={32} round={true} />
                  </FacebookShareButton>
                  <TwitterShareButton url={url}>
                    <TwitterIcon size={32} round={true} />
                  </TwitterShareButton>
                  <EmailShareButton url={url}>
                    <EmailIcon size={32} round={true} />
                  </EmailShareButton>
                </div>
              </div>

              <div className="img-wrap">
                <img className="w-full bg-light my-16" src={blok.image} />
              </div>

              <div className="leading-relaxed text-xl text-left text-gray-800 drop-cap">
                {render(blok.long_text)}
              </div>
              {story && story.tag_list && story && story.tag_list.length ?
                <div className="tags-wrap mb-2 mt-3 mb-md-4 mb-md-5">
                  <h3>Tags</h3>
                  <ul>
                    {
                      story && story.tag_list && story?.tag_list.map(el => {
                        return <li>#{el}</li>
                      })
                    }
                  </ul>
                </div>
                : ''}
            </div>
          </div>
        </section>

        <div className="bg-white-half w-full d-none">
          <div className="max-w-3xl mx-auto text-center pt-20 flex flex-col items-center">
            <p className="d-none">{blok.intro}</p>
          </div>
        </div>


        {/* <div className="">
        { related }
      </div> */}
      </SbEditable>
    </>
  )
}

export default BlogPost
